import {
    MESSENGER_CHANNEL,
    WHATSAPP_CHANNEL,
} from 'src/constants/conversations';
import { CHANNEL_BLOCK_REASON } from '../constants';
import { IChannelStrategy } from '../types';
import { blockedChannel } from './blocked';
import { messengerStrategy } from './messenger';
import { whatsappStrategy } from './whatsapp';

const STRATEGIES: Readonly<Record<string, IChannelStrategy>> = Object.freeze({
    [WHATSAPP_CHANNEL]: whatsappStrategy,
    [MESSENGER_CHANNEL]: messengerStrategy,
});

/**
 * Channels without outbound messaging (e.g. `chat`).
 */
const unsupportedStrategy: IChannelStrategy = {
    resolve: ({ conversation }) =>
        blockedChannel(
            conversation.channel,
            CHANNEL_BLOCK_REASON.UNSUPPORTED_CHANNEL
        ),
};

export const getChannelStrategy = (channel: string): IChannelStrategy =>
    STRATEGIES[channel] || unsupportedStrategy;
